import React, { useState, useRef } from "react";
import { useHover } from "react-aria";
import { Link } from "gatsby";
import "./dropdownlink.scss";
import { ChevronDown } from "react-bootstrap-icons";
import { motion } from "framer-motion";

interface idropdownProps {
  linkItem: any;
  onClick?: any;
}

const DropdownlinkMobile: React.FC<idropdownProps> = ({
  linkItem,
  ...rest
}) => {
  const [isItemOpen, setItemOpen] = React.useState(false);

  return (
    <>
      <li className="flex flex-col gap-2 !pt-0" {...rest}>
        <div className="flex flex-row justify-between w-full">
          <Link
            activeClassName="active"
            to={linkItem.url}
            style={{ position: "relative" }}
            className="flex gap-2 items-center"
          >
            {linkItem.text}
          </Link>
          {linkItem.dropdown && (
            <motion.button
              initial={false}
              animate={{ rotate: isItemOpen ? 90 : 0 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              onClick={() => setItemOpen(!isItemOpen)}
            >
              <ChevronDown className="w-6 h-6 min-w-6 min-h-6 ml-1" />
            </motion.button>
          )}
        </div>

        <motion.ul
          className="flex flex-col gap-1 w-full dropdownlinkmobile !p-0"
          initial={false}
          animate={{
            height: isItemOpen ? "auto" : 0,
            opacity: isItemOpen ? 1 : 0,
          }}
          transition={{
            height: { duration: 0.6, ease: "easeInOut" },
            opacity: { duration: 0.6, ease: "easeInOut" },
          }}
        >
          {linkItem?.dropdown?.map((dropdownItem: any, dropdownidx: number) => (
            <li key={dropdownidx} className="!text-base !py-0.5">
              <Link
                className="!text-base"
                activeClassName="active"
                to={dropdownItem.urlDropdown}
              >
                {dropdownItem.textDropdown}
              </Link>
            </li>
          ))}
        </motion.ul>
      </li>
    </>
  );
};

export default DropdownlinkMobile;
